import type { ReactNode } from 'react';
import RangeTabs from './RangeTabs';
import type { RangeKey } from '../../lib/range';

export default function PageHeader({
  title,
  desc,
  range,
  extra,
}: {
  title: string;
  desc?: string;
  range?: {
    key: RangeKey;
    setRange: (key: RangeKey) => void;
    customFrom?: string;
    customTo?: string;
    setCustomRange?: (from: string, to: string) => void;
  };
  extra?: ReactNode;
}) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div>
        <h1 className="font-heading text-2xl font-bold text-foreground-950">{title}</h1>
        {desc && <p className="mt-1 text-sm text-foreground-600">{desc}</p>}
      </div>
      <div className="flex flex-wrap items-center justify-end gap-3">
        {extra}
        {range && (
          <RangeTabs
            value={range.key}
            onChange={range.setRange}
            customFrom={range.customFrom}
            customTo={range.customTo}
            onCustomChange={range.setCustomRange}
          />
        )}
      </div>
    </div>
  );
}
